@if (shouldDisplay()) {
    <mat-icon svgIcon="warning" />
    <div>
        @if (hasKYCExpired) {
            {{
                'payroll.kyc-kyb.banner.messageExpired.0'
                    | translate: { scope: ('payroll.kyc-kyb.scopes.' + scope() | translate) }
            }}
            <a [routerLink]="linkToPreRedirect">{{
                'payroll.kyc-kyb.banner.messageExpired.1'
                    | translate: { scope: ('payroll.kyc-kyb.scopes.' + scope() | translate) }
            }}</a
            >{{ 'payroll.kyc-kyb.banner.messageExpired.2' | translate }}
        } @else {
            {{
                'payroll.kyc-kyb.banner.messageWithWave.0'
                    | translate
                        : {
                              days: verificationDays,
                              scope: ('payroll.kyc-kyb.scopes.' + scope() | translate),
                              date: (KYBKYCExpirationDate | appDate: 'longDate'),
                          }
            }}
            <a [routerLink]="linkToPreRedirect">{{ 'payroll.kyc-kyb.banner.messageWithWave.1' | translate }}</a
            >{{ 'payroll.kyc-kyb.banner.messageWithWave.2' | translate }}
        }
    </div>
}
